import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { isMobile } from '../_app/cuchillo/core/Basics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';

export class ScrollItem__TeamList extends ScrollItem__BlockDefault {
    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }

    setAnimations() {
        super.setAnimations();

        if (!isMobile) {
            this.item.style.setProperty("--column", Maths.maxminRandom(3, 1));
        }
    }
}

Scroll._registerClass('TeamList', ScrollItem__TeamList);
